import DealerCallbackRequestForm from './components/dealer-callback-request-form.js';

(function($,w) {
    $(function() {
        $("form[dealer-callback-request-form]").each(function () {
            new DealerCallbackRequestForm().init(this);
        });
    });
})(jQuery, window)

